import DatasetsList from '../business360/DatasetsList';

export default function Business360() {
  return (
    <div className="container">
      <h1 style={{ marginBottom: 0 }}>Business 360</h1>
      <p className="muted" style={{ marginTop: 4, marginBottom: 24 }}>
        Discovered painter datasets from Business 360. Read-only — open a dataset to browse its
        verified painters and the citations behind each one.
      </p>
      <DatasetsList />
    </div>
  );
}
